import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, isValid, isDirty, submit } from 'redux-form';

import * as VendorLinkIntegrationSelectors from 'Pages/vendorlinkintegration/state/selectors';
import * as VendorLinkIntegrationActions from 'Pages/vendorlinkintegration/state/actions';
import { VendorLinkConfigurationForm } from './VendorLinkConfigurationForm';
import { VENDORLINK_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { LoadingPage, NotificationMessage } from 'Components';
import { Main } from 'Containers/';

export class VendorLinkConfigurationStepContainer extends Component {
  static stepInfo = {
    icon: 'configure',
    title: 'Configuration',
    description: 'Configure VendorLink credentials',
  };

  state = {
    leaIdModalOpen: false,
    leaIds: null,
    beenTested: false,
  };

  componentDidMount() {
    const { getConfiguration } = this.props;
    getConfiguration();
  }

  componentDidUpdate(prevProps) {
    const {
      getConfigurationErrors,

      postGetLeaInfoRefIdsResult,
      postGetLeaInfoRefIdsErrors,
      clearPostGetLeaInfoRefIdsResult,

      postTestConnectionResult,
      postTestConnectionErrors,
      clearPostTestConnectionResult,

      setConfigurationResult,
      setConfigurationErrors,
      clearSetConfigurationResult,

      setStepCompleted,

      getSites,
    } = this.props;

    //redux updates
    if (getConfigurationErrors) {
      errorToast(this.props, prevProps, 'getConfigurationErrors');
    }

    if (postGetLeaInfoRefIdsResult || postGetLeaInfoRefIdsErrors) {
      if (!errorToast(this.props, prevProps, 'postGetLeaInfoRefIdsErrors')) {
        this.setState({
          leaIds: postGetLeaInfoRefIdsResult,
          leaIdModalOpen: true,
        });
      }

      clearPostGetLeaInfoRefIdsResult();
    }

    if (setConfigurationResult || setConfigurationErrors) {
      if (!errorToast(this.props, prevProps, 'setConfigurationErrors')) {
        NotificationMessage({ Data: setConfigurationResult, Errors: [] });

        this.setState({ leaIdModalOpen: false, beenTested: false });
        setStepCompleted(false);
      }

      clearSetConfigurationResult();
    }

    if (postTestConnectionResult || postTestConnectionErrors) {
      if (!errorToast(this.props, prevProps, 'postTestConnectionErrors')) {
        if (postTestConnectionResult.passed) {
          createToast(
            toastType.success,
            'Success',
            'Connection successful',
            true
          );

          this.setState({ beenTested: true });
          setStepCompleted(true);

          getSites();
        } else {
          createToast(
            toastType.error,
            'Error',
            'Incorrect VendorLink credentials or VendorLink is currently down.'
          );

          const endpoints = Object.keys(postTestConnectionResult)
            .filter(key => key !== 'passed' && !postTestConnectionResult[key])
            .join(', ');

          createToast(
            toastType.warning,
            'Warning',
            `Unable to access the following endpoints: ${endpoints}`,
            true,
            20 * 1000
          );
        }
      }

      clearPostTestConnectionResult();
    }
  }

  /** generate toolbar buttons */
  getMainProps = () => {
    const {
      getConfigurationLoading,
      postGetLeaInfoRefIdsLoading,
      postTestConnectionLoading,

      postGetLeaInfoRefIds,
      postTestConnection,
      configFormValues,

      isConfigDirty,
      isConfigValid,

      stepCompleted,
      goToNextStep,
    } = this.props;

    const { beenTested } = this.state;

    const mainProps = {
      toolbox: {
        shown: true,
        rightButtons: [
          {
            content: 'Choose LEA Info Ref ID and Save',
            loading: postGetLeaInfoRefIdsLoading,
            disabled:
              getConfigurationLoading ||
              postGetLeaInfoRefIdsLoading ||
              postTestConnectionLoading,
            onClick: () => postGetLeaInfoRefIds(configFormValues),
          },
          {
            content: 'Test',
            loading: postTestConnectionLoading,
            disabled:
              getConfigurationLoading ||
              postGetLeaInfoRefIdsLoading ||
              postTestConnectionLoading ||
              isConfigDirty ||
              !isConfigValid,
            onClick: () => postTestConnection(configFormValues),
          },
        ],
      },
    };

    if (beenTested) {
      mainProps.toolbox.rightButtons.push({
        content: 'Next',
        disabled:
          getConfigurationLoading ||
          postGetLeaInfoRefIdsLoading ||
          postTestConnectionLoading ||
          !stepCompleted,
        onClick: goToNextStep,
      });
    }

    return mainProps;
  };

  render() {
    const {
      getConfigurationLoading,
      getConfigurationResult,

      setConfiguration,

      isConfigDirty,
      isConfigValid,

      submit,
    } = this.props;

    const { leaIdModalOpen, leaIds } = this.state;

    const mainProps = this.getMainProps();

    return getConfigurationLoading ? (
      <LoadingPage />
    ) : (
      <Main {...mainProps}>
        <VendorLinkConfigurationForm
          initialValues={getConfigurationResult}
          leaIdModalOpen={leaIdModalOpen}
          leaIds={leaIds}
          setLeaIdModalOpen={open => this.setState({ leaIdModalOpen: open })}
          saveButtonDisabled={!isConfigDirty || !isConfigValid}
          submit={submit}
          onSubmit={values => setConfiguration(values)}
        />
      </Main>
    );
  }
}

const mapStateToProps = state => {
  return {
    getConfigurationLoading: VendorLinkIntegrationSelectors.getConfigurationLoading(
      state
    ),
    getConfigurationResult: VendorLinkIntegrationSelectors.getConfigurationResult(
      state
    ),
    getConfigurationErrors: VendorLinkIntegrationSelectors.getConfigurationErrors(
      state
    ),

    postGetLeaInfoRefIdsLoading: VendorLinkIntegrationSelectors.postGetLeaInfoRefIdsLoading(
      state
    ),
    postGetLeaInfoRefIdsResult: VendorLinkIntegrationSelectors.postGetLeaInfoRefIdsResult(
      state
    ),
    postGetLeaInfoRefIdsErrors: VendorLinkIntegrationSelectors.postGetLeaInfoRefIdsErrors(
      state
    ),

    postTestConnectionLoading: VendorLinkIntegrationSelectors.postTestConnectionLoading(
      state
    ),
    postTestConnectionResult: VendorLinkIntegrationSelectors.postTestConnectionResult(
      state
    ),
    postTestConnectionErrors: VendorLinkIntegrationSelectors.postTestConnectionErrors(
      state
    ),

    setConfigurationLoading: VendorLinkIntegrationSelectors.setConfigurationLoading(
      state
    ),
    setConfigurationResult: VendorLinkIntegrationSelectors.setConfigurationResult(
      state
    ),
    setConfigurationErrors: VendorLinkIntegrationSelectors.setConfigurationErrors(
      state
    ),

    configFormValues: getFormValues(VENDORLINK_CONFIGURATION_FORM_NAME)(state),
    isConfigValid: isValid(VENDORLINK_CONFIGURATION_FORM_NAME)(state),
    isConfigDirty: isDirty(VENDORLINK_CONFIGURATION_FORM_NAME)(state),
  };
};

const mapDispatchToProps = {
  submit,

  getConfiguration: VendorLinkIntegrationActions.getConfiguration,

  postGetLeaInfoRefIds: VendorLinkIntegrationActions.postGetLeaInfoRefIds,
  clearPostGetLeaInfoRefIdsResult:
    VendorLinkIntegrationActions.clearPostGetLeaInfoRefIdsResult,

  postTestConnection: VendorLinkIntegrationActions.postTestConnection,
  clearPostTestConnectionResult:
    VendorLinkIntegrationActions.clearPostTestConnectionResult,

  setConfiguration: VendorLinkIntegrationActions.setConfiguration,
  clearSetConfigurationResult:
    VendorLinkIntegrationActions.clearSetConfigurationResult,

  getSites: VendorLinkIntegrationActions.getSites,
};

export const VendorLinkConfigurationStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorLinkConfigurationStepContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkConfigurationStep/VendorLinkConfigurationStep.js